import { TMapItemSubKind } from "components/store";
import Fill from "ol/style/Fill";
import Icon from "ol/style/Icon";
import Stroke from "ol/style/Stroke";
import Style from "ol/style/Style";
import Text from "ol/style/Text";



export const labelStyleBox = new Style({
    text: new Text({
        font: `14px 'Roboto', sans-serif`,
        overflow: true,
        fill: new Fill({
            color: '#000'
        }),
        backgroundFill: new Fill({
            color: '#fff'
        }),
        backgroundStroke: new Stroke({
            color: '#000',
            width: 1
        }),
        padding: [8, 10, 5, 10],
        offsetY: -20
    })
});


export const iconStyleSelected = new Style({
    ...(typeof document != 'undefined') && {
        image: new Icon({
            //anchor: [0.5, 46],
            anchorXUnits: 'fraction',
            anchorYUnits: 'pixels',
            src: '/kek_baj_selected.png',
            scale: 0.1
        })
    }
});
export const selectionStyleX = new Style({
    ...(typeof document != 'undefined') && {
        image: new Icon({
            anchor: [.505, 450],
            anchorXUnits: 'fraction',
            anchorYUnits: 'pixels',
            src: '/selection.png',
            scale: 0.1
        })
    }
});
export const selectionStyle = new Style({
    ...(typeof document != 'undefined') && {
        image: new Icon({
            anchor: [.505, 2.4],
            anchorXUnits: 'fraction',
            anchorYUnits: 'fraction',
            src: '/selection2.png',
            scale: 0.2
        })
    }
});

export const labelStyleGroup = (fontSize: string = '18px') => new Style({
    text: new Text({
        font: `${fontSize} 'Roboto', sans-serif`,
        overflow: true,
        /*backgroundFill: new Fill({
            color: color
        }),
        padding: [4,10,0,10],*/
        fill: new Fill({
            color: '#fff'
        }),
        textAlign: 'center',
        offsetY: -42,
        offsetX: 0,
    })
});

export const labelStyleGroupCaption = () => new Style({
    text: new Text({
        font: `bold 15px 'Roboto', sans-serif`,
        overflow: true,
        fill: new Fill({ color: '#0b273f' }),
        stroke: new Stroke({ color: '#fff', width:2}),
        textAlign: 'center',
        offsetY: 0,//50,
        offsetX: 0,
    })
});

export const labelStyleGuard = new Style({
    text: new Text({
        font: `bold 15px 'Roboto', sans-serif`,
        
        overflow: true,
        fill: new Fill({ color: '#0b273f' }),
        stroke: new Stroke({ color: '#fff', width:2}),
        textAlign: 'center',
        offsetY: 20,
        offsetX: 0,
    })
});

//https://www.svgrepo.com/svg/307018/guard?edit=true
export const guardStyle = new Style({
    ...(typeof document != 'undefined') && {
        image: new Icon({
            //anchor: [0.5, 46],
            anchorXUnits: 'fraction',
            anchorYUnits: 'pixels',
            src: '/map/pin_guard_ormester.png',
            scale: 0.10
        })
    }
});



// ---------------------------------------------- NEW ICONS ----------------------------------------
const SCALE = .083;
const GUARD_SCALE = .1;
const TOP = 620;
export const iconStyleBySubKind: { [key in TMapItemSubKind]: Style } = {
    'vizminoseg': new Style({
        ...(typeof document != 'undefined') && {
            image: new Icon({
                anchor: [0.5, TOP],
                anchorXUnits: 'fraction',
                anchorYUnits: 'pixels',
                src: '/map/pin4_vizminoseg.png',
                scale: SCALE,
            })
        }
    }),
    'csotores': new Style({
        ...(typeof document != 'undefined') && {
            image: new Icon({
                anchor: [0.5, TOP],
                anchorXUnits: 'fraction',
                anchorYUnits: 'pixels',
                src: '/map/pin4_csotores.png',
                scale: SCALE,
            })
        }
    }),
    'kozkut': new Style({
        ...(typeof document != 'undefined') && {
            image: new Icon({
                anchor: [0.5, TOP],
                anchorXUnits: 'fraction',
                anchorYUnits: 'pixels',
                src: '/map/pin4_kozkut.png',
                scale: SCALE,
            })
        }
    }),
    'dugulas': new Style({
        ...(typeof document != 'undefined') && {
            image: new Icon({
                anchor: [0.5, TOP],
                anchorXUnits: 'fraction',
                anchorYUnits: 'pixels',
                src: '/map/pin4_dugulas.png',
                scale: SCALE,
            })
        }
    }),
    'eloviz': new Style({
        ...(typeof document != 'undefined') && {
            image: new Icon({
                anchor: [0.5, TOP],
                anchorXUnits: 'fraction',
                anchorYUnits: 'pixels',
                src: '/map/pin4_eloviz.png',
                scale: SCALE,
            })
        }
    }),
    // -------------------------------------------------------------- GUARDS ---------------------------
    '00': new Style({
        ...(typeof document != 'undefined') && {
            image: new Icon({
                anchor: [0.5, 400],
                anchorXUnits: 'fraction',
                anchorYUnits: 'pixels',
                src: '/map/guard2_00.png',
                opacity: 1,
                scale: GUARD_SCALE
            })
        }
    }),
    '10': new Style({
        ...(typeof document != 'undefined') && {
            image: new Icon({
                anchor: [0.5, 400],
                anchorXUnits: 'fraction',
                anchorYUnits: 'pixels',
                src: '/map/guard2_10.png',
                opacity: 1,
                scale: GUARD_SCALE
            })
        }
    }),
    '20': new Style({
        ...(typeof document != 'undefined') && {
            image: new Icon({
                anchor: [0.5, 400],
                anchorXUnits: 'fraction',
                anchorYUnits: 'pixels',
                src: '/map/guard2_20.png',
                opacity: 1,
                scale: GUARD_SCALE
            })
        }
    }),
    '25': new Style({
        ...(typeof document != 'undefined') && {
            image: new Icon({
                anchor: [0.5, 400],
                anchorXUnits: 'fraction',
                anchorYUnits: 'pixels',
                src: '/map/guard2_25.png',
                opacity: 1,
                scale: GUARD_SCALE
            })
        }
    }),
    '30': new Style({
        ...(typeof document != 'undefined') && {
            image: new Icon({
                anchor: [0.5, 400],
                anchorXUnits: 'fraction',
                anchorYUnits: 'pixels',
                src: '/map/guard2_30.png',
                opacity: 1,
                scale: GUARD_SCALE
            })
        }
    }),
    // -------------------------------------------------------------- GROUP ---------------------------
    'group_vizminoseg': new Style({
        ...(typeof document != 'undefined') && {
            image: new Icon({
                anchor: [0.5, 700],
                anchorXUnits: 'fraction',
                anchorYUnits: 'pixels',
                src: '/map/pin4_vizminoseg_ures.png',
                scale: SCALE
            })
        }
    }),
    'group_csotores': new Style({
        ...(typeof document != 'undefined') && {
            image: new Icon({
                anchor: [0.5, 700],
                anchorXUnits: 'fraction',
                anchorYUnits: 'pixels',
                src: '/map/pin4_csotores_ures.png',
                scale: SCALE
            })
        }
    }),
    'group_dugulas': new Style({
        ...(typeof document != 'undefined') && {
            image: new Icon({
                anchor: [0.5, 700],
                anchorXUnits: 'fraction',
                anchorYUnits: 'pixels',
                src: '/map/pin4_dugulas_ures.png',
                scale: SCALE
            })
        }
    }),
    'group_kozkut': new Style({
        ...(typeof document != 'undefined') && {
            image: new Icon({
                anchor: [0.5, 700],
                anchorXUnits: 'fraction',
                anchorYUnits: 'pixels',
                src: '/map/pin4_kozkut_ures.png',
                scale: SCALE
            })
        }
    }),
    'group_eloviz': new Style({
        ...(typeof document != 'undefined') && {
            image: new Icon({
                anchor: [0.5, 700],
                anchorXUnits: 'fraction',
                anchorYUnits: 'pixels',
                src: '/map/pin4_eloviz_ures.png',
                scale: SCALE
            })
        }
    }),
    // -------------------------------------------------------------- GROUP ---------------------------
    'findcity': new Style({
        ...(typeof document != 'undefined') && {
            image: new Icon({
                //anchor: [0.5, 46],
                anchorXUnits: 'fraction',
                anchorYUnits: 'pixels',
                src: '/kek_baj.png',
                scale: 0.1
            })
        }

    }),



}


export const PIN_SELECTED = new Style({
    ...(typeof document != 'undefined') && {
        image: new Icon({
            anchor: [0.5, 700],
            anchorXUnits: 'fraction',
            anchorYUnits: 'pixels',
            src: '/map/pin.png',
            scale: 0.1
        })
    }

});